module.exports = __webpack_public_path__ + "static/media/5.15.ef2fe01c.png";